/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Jobs_Save_VariantInputs */

const en_jobs_save_variant = /** @type {(inputs: Jobs_Save_VariantInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Save Variant`)
};

const de_jobs_save_variant = /** @type {(inputs: Jobs_Save_VariantInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Variante speichern`)
};

const fr_jobs_save_variant = /** @type {(inputs: Jobs_Save_VariantInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Enregistrer la variante`)
};

const es_jobs_save_variant = /** @type {(inputs: Jobs_Save_VariantInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Guardar variante`)
};

const it_jobs_save_variant = /** @type {(inputs: Jobs_Save_VariantInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Salva variante`)
};

const nl_jobs_save_variant = /** @type {(inputs: Jobs_Save_VariantInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Variant opslaan`)
};

const pl_jobs_save_variant = /** @type {(inputs: Jobs_Save_VariantInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zapisz wariant`)
};

const fi_jobs_save_variant = /** @type {(inputs: Jobs_Save_VariantInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tallenna versio`)
};

const da_jobs_save_variant = /** @type {(inputs: Jobs_Save_VariantInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gem variant`)
};

const sv_jobs_save_variant = /** @type {(inputs: Jobs_Save_VariantInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Spara variant`)
};

/**
* | output |
* | --- |
* | "Save Variant" |
*
* @param {Jobs_Save_VariantInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const jobs_save_variant = /** @type {((inputs?: Jobs_Save_VariantInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Jobs_Save_VariantInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_jobs_save_variant(inputs)
	if (locale === "fr") return fr_jobs_save_variant(inputs)
	if (locale === "es") return es_jobs_save_variant(inputs)
	if (locale === "it") return it_jobs_save_variant(inputs)
	if (locale === "nl") return nl_jobs_save_variant(inputs)
	if (locale === "pl") return pl_jobs_save_variant(inputs)
	if (locale === "fi") return fi_jobs_save_variant(inputs)
	if (locale === "da") return da_jobs_save_variant(inputs)
	if (locale === "sv") return sv_jobs_save_variant(inputs)
	return en_jobs_save_variant(inputs)
});